import React, { useEffect } from 'react';
import { BrowserRouter } from "react-router-dom";
import { App as AntdApp, ConfigProvider } from 'antd';
import { RootStoreContext } from './stores/root-store-context';
import RootStore from './stores/root-stores';
import Router from './routes/Router';
import './i18n';
import './App.css';
import 'react-quill/dist/quill.snow.css';
import i18n from './i18n';
import { getAntdLocale } from './helpers/locales';
import { GoogleOAuthProvider } from '@react-oauth/google';
import FontProvider from './components/elements/KanbanBoard/Font/FontProvider';
import { observer } from 'mobx-react-lite';

type SiteConfig = {
  lang: string;
  domain: string;
  showLanguage: boolean;
}
const App: React.FC = observer(() => {
  const [store] = React.useState(() => new RootStore());

  React.useEffect(() => {
    const onLogout = () => {
      window.location.href = "/login";
    };
    window.addEventListener("app:logout", onLogout);
    return () => window.removeEventListener("app:logout", onLogout);
  }, []);

  const fonts = React.useMemo(() => {
    if (store.applicationStore.company?.FontsJson) {
      try {
        return JSON.parse(store.applicationStore.company.FontsJson);
      } catch {
        return {};
      }
    }
    return {};
  }, [store.applicationStore.company?.FontsJson]);
  
  return (
    <FontProvider fonts={fonts}>
      <ConfigProvider locale={getAntdLocale(i18n.language)}>
        <RootStoreContext.Provider value={store}>
          <GoogleOAuthProvider clientId="522104468705-r41tkugbe1cutsss81l36bk3n9qsropb.apps.googleusercontent.com">
            <AntdApp>
              <BrowserRouter>
                <Router />
              </BrowserRouter>
            </AntdApp>
          </GoogleOAuthProvider>
        </RootStoreContext.Provider>
      </ConfigProvider>
    </FontProvider>
  );
});

export default App;